import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { Country } from "@omni/types/enums/country.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { Path } from "react-hook-form";

import { AddressContainer } from "@/components/Address/Address/address.container";
import { AddressBookModalFormValues } from "@/components/Checkout/CheckoutCustomer/addresses/components/addressListModal/addressListModal.schema";
import { useAddressBook } from "@/components/Checkout/CheckoutCustomer/addresses/context/addressBook.context";
import { FormGroup } from "@/components/Form/Base/formGroup.component";
import { Input } from "@/components/Form/Base/input.component";
import { Label } from "@/components/Form/Base/label.component";
import { BaseField } from "@/components/Form/RHF/FormFields/BaseField/BaseField.component";
import { Td } from "@/components/General/Table/td.component";
import { Tr } from "@/components/General/Table/tr.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    address: CloudCustomerAddress;
};

export const AddressRow = ({ address }: Props) => {
    const { t } = useGranite();

    const { type, disabledIds, openAddressForm } = useAddressBook();

    const disabled =
        (type === AddressType.Delivery && address?.country !== Country.Be) ||
        disabledIds.includes(address.id);

    const handleOnEditClick = () => {
        if (disabled) return;

        openAddressForm({ type: type, id: address.id });
    };

    return (
        <Tr className={cn({ "tw:opacity-30": disabled })}>
            <Td className={cn("tw:align-middle")}>
                <BaseField<
                    AddressBookModalFormValues,
                    Path<AddressBookModalFormValues>
                >
                    name={"addressId"}
                    label={""}
                    required={false}
                    hideLabel={true}
                    hideMicroCopy={true}
                >
                    {({ field }) => {
                        return (
                            <FormGroup toggle={true}>
                                <Label>
                                    <Input
                                        {...field}
                                        type={"radio"}
                                        value={address.id}
                                        checked={field.value === address.id}
                                        disabled={disabled}
                                    />
                                </Label>
                            </FormGroup>
                        );
                    }}
                </BaseField>
            </Td>
            <Td className={cn("tw:align-middle tw:w-full")}>
                <label htmlFor={address.id}>
                    <AddressContainer
                        address={address}
                        addressType={type}
                    />
                </label>
            </Td>
            <Td className={cn("tw:align-middle")}>
                {!disabled && (
                    <Button
                        test="addressRow-button-edit"
                        color="link"
                        type="button"
                        className={cn("tw:text-nowrap")}
                        onClick={handleOnEditClick}
                    >
                        <i className={cn("las la-pencil-alt", "tw:mr-2")} />
                        <span className={cn("tw:hidden tw:md:inline")}>
                            {t("general.addressBook.modal.edit.adress")}
                        </span>
                    </Button>
                )}
            </Td>
        </Tr>
    );
};
